import React, { useCallback } from "react"
import { Grid, Typography, Box, Button } from "@material-ui/core"

import useStyles from "@/pages/Attendance/ReferralPopup/screens/ReferralOfferScreen/styles"
import { useAnimatedCounter, useCountdown } from "@/pages/Attendance/ReferralPopup/screens/ReferralOfferScreen/useCountdown"
import {
	REFERRAL_REWARD_AMOUNT,
	REFERRAL_DEADLINE
} from "@/pages/Attendance/ReferralPopup/constants"
import { ReferralOfferScreenProps } from "@/pages/Attendance/ReferralPopup/types"

const ReferralOfferScreen: React.FC<ReferralOfferScreenProps> = (props) => {
	const { isAdmin, onClaim, onClose } = props
	const classes = useStyles()

	const animatedValue = useAnimatedCounter(REFERRAL_REWARD_AMOUNT)
	const countdownText = useCountdown(REFERRAL_DEADLINE)

	const handleClaimClick = useCallback(() => {
		onClaim()
	}, [onClaim])

	const handleDismissClick = useCallback(() => {
		onClose()
	}, [onClose])

	const renderAdminHeader = (): React.ReactNode => {
		return (
			<Box className={classes.headerContent}>
				<Box className={classes.badge}>
					<Box className={classes.badgeDot} />
					<Typography component="span">{"INDIQUE E GANHE"}</Typography>
				</Box>
				<Typography className={classes.title}>
					{"Sua campanha, montada com você"}
				</Typography>
				<Box className={classes.rewardRow}>
					<Box className={`${classes.rewardCard} ${classes.coinPop}`}>
						<Typography className={classes.rewardCardText}>
							{"30 minutos com nosso time de tráfego"}
						</Typography>
					</Box>
					<Typography className={classes.rewardPlus}>{"+"}</Typography>
					<Box className={`${classes.rewardCard} ${classes.coinPop}`}>
						<Typography className={classes.rewardCardText}>
							{`R$ ${animatedValue} de verba`}
						</Typography>
					</Box>
				</Box>
				<Typography className={classes.reservedText}>
					{"Já está reservado no seu nome."}
				</Typography>
			</Box>
		)
	}

	const renderAttendantHeader = (): React.ReactNode => {
		return (
			<Box className={classes.headerContent}>
				<Box className={classes.badge}>
					<Box className={classes.badgeDot} />
					<Typography component="span">{"PRESENTE DA LETALK"}</Typography>
				</Box>
				<Typography className={classes.titleAtendente}>
					{"Você ganhou"}
				</Typography>
				<Box className={classes.rewardRow}>
					<Typography className={classes.valuePrefix}>{"R$"}</Typography>
					<Typography className={classes.valueCounter}>
						{animatedValue}
					</Typography>
				</Box>
			</Box>
		)
	}

	return (
		<Grid container direction="column">
			<Box className={classes.header}>
				<Box className={classes.blobOne} />
				<Box className={classes.blobTwo} />
				<Box className={classes.dotTexture} />
				{isAdmin ? renderAdminHeader() : renderAttendantHeader()}
			</Box>
			<Box className={classes.body}>
				<Box className={classes.countdownRow}>
					<Typography component="span" className={classes.countdownIcon}>
						{"⏱"}
					</Typography>
					<Typography component="span">
						{`Sua reserva expira em ${countdownText}`}
					</Typography>
				</Box>
				<Box className={classes.ctaColumn}>
					<Button
						type="button"
						className={classes.resgatarButton}
						onClick={handleClaimClick}
						disableElevation
					>
						{"Resgatar"}
					</Button>
					<Button
						type="button"
						className={classes.agoraNaoLink}
						onClick={handleDismissClick}
						disableElevation
					>
						{"agora não"}
					</Button>
				</Box>
			</Box>
		</Grid>
	)
}

export default ReferralOfferScreen
